<p-dialog
  [(visible)]="visible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '450px', height: 'auto' }"
  (visibleChange)="visibleChange.emit($event)">

  <!-- HEADER CUSTOMIZADO COM WAVE -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-sliders-h" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.titulo }}</h2>
        <p>{{ texts.subtitulo }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">

    <!-- Loading -->
    <div *ngIf="carregando" class="flex justify-content-center p-4">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
    </div>

    <!-- Sem unidades disponiveis -->
    <div *ngIf="!carregando && unidadesDisponiveis.length === 0" class="empty-state">
      <i class="pi pi-info-circle" style="font-size: 2rem; color: #94a3b8;"></i>
      <p>{{ texts.mensagens_nenhuma_disponivel }}</p>
    </div>

    <!-- Dropdown de selecao -->
    <div *ngIf="!carregando && unidadesDisponiveis.length > 0" class="field">
      <label for="unidadeSelect">{{ texts.labels_unidade }} *</label>
      <p-dropdown
        inputId="unidadeSelect"
        [options]="unidadesDisponiveis"
        [(ngModel)]="unidadeSelecionada"
        optionLabel="nome"
        [placeholder]="texts.placeholders_selecione_unidade"
        [filter]="true"
        [showClear]="true"
        appendTo="body"
        panelStyleClass="dropdown-panel-above-modal"
        styleClass="w-full">
      </p-dropdown>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="fechar()" [disabled]="salvando">
      {{ texts.botoes_fechar }} (Esc)
    </button>
    <button pButton (click)="submit()" [disabled]="salvando || carregando || unidadesDisponiveis.length === 0">
      <i *ngIf="salvando" class="pi pi-spin pi-spinner mr-2"></i>
      {{ texts.botoes_vincular }}
    </button>
  </ng-template>
</p-dialog>
